import { render, staticRenderFns } from "./page-create-meditation-category.vue?vue&type=template&id=5dcc5f72&"
import script from "./page-create-meditation-category.vue?vue&type=script&lang=ts&"
export * from "./page-create-meditation-category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports